/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Permission_Hint_ToggleInputs */



/**
* | output |
* | --- |
* | "What happens to the connection?" |
*
* @param {Integrations_Permission_Hint_ToggleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_permission_hint_toggle = /** @type {((inputs?: Integrations_Permission_Hint_ToggleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Permission_Hint_ToggleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was passiert mit der Verbindung?")
	return /** @type {LocalizedString} */ ("What happens to the connection?")
});